import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 客户端 消息提醒类型
 */
class UserMessageType extends UltMeta {
    All = new Meta(0, "全部");
    CONTRACT = new Meta(7, "合同");
    ORDER = new Meta(1, "订单");
    FUNDING = new Meta(5, "资金");
    INVENTORY = new Meta(10, "仓储");
    OTHER = new Meta(9, "其他");
}
export const USER_MESSAGE_TYPE = new UserMessageType();

/**
 * 客户端 消息提醒状态
 */
class UserMessageState extends UltMeta {
    UNREAD = new Meta(1, "未读");
    READED = new Meta(2, "已读");
}
export const USER_MESSAGE_STATE = new UserMessageState();

/**
 * 客户端 跳转对应详情的常量 UserMessageConstants
 */
export enum UserMessageConstants {
    /**
     * 项目详情
     */
    STORE_DETAIL_PAGE = "1",

    /**
     * 采购订单详情页
     */
    FIND_BOAT_DETAIL_PAGE = "2",

    /**
     * 提货详情
     */
    DELIVER_GOODS_DETAIL_PAGE = "3",

    /**
     * 签收详情
     */
    SIGN_RECEIPT_DETAIL_PAGE = "4",

    /**
     * 结算详情
     */
    RECONCILIATION_DETAIL_PAGE = "5",

    /**
     * 开票详情
     */
    BILL_PAYMENT_DETAIL_PAGE = "6",

    /**
     * 付款详情
     */
    PAYMENT_DETAIL_PAGE = "7",

    /**
     * 合同详情
     */
    CONTRACT_DETAIL_PAGE = "8",

    /**
     * 组织机构认证详情
     */
    INSTITUTION_APPLY_DETAIL_PAGE = "9",

    /**
     * 受邀记录详情
     */
    CUSTOMER_ENTERPRISE_APPLY_DETAIL_PAGE = "10",

    /**
     * 额度变更详情
     */
    QUOTA_CHANGE_APPLY_DETAIL_PAGE = "11",

    /**
     * 退款详情
     */
    REFUND_DETAIL_PAGE = "12",

    /**
     * 服务费详情
     */
    SERVICE_FEE_DETAIL_PAGE = "13",

    /**
     * 融资详情页
     */
    FINANCING_DETAIL_PAGE = "14",

    /**
     * 借据管理
     */
    LOAN_RECEIPT_DETAIL_PAGE = "15",

    /**
     * 还款详情页
     */
    REPAYMENT_DETAIL_PAGE = "16",

    /**
     * 入库详情页
     */
    INBOUND_DETAIL_PAGE = "17",

    /**
     * 出库详情页
     */
    OUTBOUND_DETAIL_PAGE = "18",

    /**
     * 盘点详情页
     */
    STOCKTAKING_DETAIL_PAGE = "19",

    /**
     * 抽检详情页
     */
    STOCK_CHECK_DETAIL_PAGE = "20",

    /**
     * 质押详情页
     */
    PLEDGE_DETAIL_PAGE = "21",

    /**
     * 仓储业务 - 合同详情页
     */
    SUPERVISION_CONTRACT_DETAIL_PAGE = "22",

    /**
     * 仓储业务 - 仓储管理 - 盘点详情页
     */
    SUPERVISION_STOCKTAKING_DETAIL_PAGE = "23",

    /**
     * 仓储业务 - 仓储管理 - 抽检详情页
     */
    SUPERVISION_STOCK_CHECK_DETAIL_PAGE = "24",

    /**
     * 仓储业务 - 仓储管理 - 入库详情页
     */
    SUPERVISION_INBOUND_DETAIL_PAGE = "25",

    /**
     * 仓储业务 - 仓储管理 - 出库详情页
     */
    SUPERVISION_OUTBOUND_DETAIL_PAGE = "26",

    /**
     * 仓储业务 - 仓储管理 - 过户详情页
     */
    SUPERVISION_TRANSFER_DETAIL_PAGE = "27",

    /**
     * 进销存 - 收款详情页
     */
    BE_PAYMENT_DETAIL_PAGE = "28",

    /**
     * 进销存 - 销售订单详情页
     */
    SEAL_FIND_BOAT_DETAIL_PAGE = "29",

    /**
     * 进销存 - 销售签收详情
     */
    SEAL_SIGN_RECEIPT_DETAIL_PAGE = "30",

    /**
     * 进销存 - 销售对账详情
     */
    SEAL_RECONCILIATION_DETAIL_PAGE = "31",

    /**
     * 进销存 - 销售开票详情
     */
    SEAL_BILL_PAYMENT_DETAIL_PAGE = "32",

    /** 仓储业务 - 仓储管理 - 质押详情页 */
    SUPERVISION_PLEDGE_DETAIL_PAGE = "33",

    /** 我的企业管理 - 我的企业列表 */
    MAIN_BODY_LIST_PAGE = "34",

    /**
     * 仓储管理 - 合同详情
     */
    STORE_CONTRACT_DETAIL_PAGE = "35",
    /**
     * 仓储管理 - 入库详情
     */
    STORE_INBOUND_DETAIL_PAGE = "36",
    /**
     * 仓储管理 - 出库详情
     */
    STORE_OUTBOUND_DETAIL_PAGE = "37",
    /**
     * 进销存 - 入库详情
     */
    DEAL_INBOUND_DETAIL_PAGE = "38",
    /**
     * 进销存 - 出库详情
     */
    DEAL_OUTBOUND_DETAIL_PAGE = "39"
}
